<div layout="column" flex>
    <div class="iwg-summary" layout="row" layout-xs="column" *ngIf="summary">
        <div flex *ngFor="let item of summary" [ngClass]="{'iwg-summary-item-selected': (selectedSummaryItem?.FilterName == item.FilterName
                        && selectedSummaryItem?.FilterValue == item.FilterValue)}" (click)="changeSummary(item)">
            <div class="iwg-value">{{item.Value}}</div>
            <div class="iwg-label">{{item.Name}}</div>
        </div>
    </div>
    <div>
        <mat-tab-group animationDuration="0ms" [(selectedIndex)]="selectedTabIndex"
                       (selectedTabChange)="onTabChanged($event);">
            <mat-tab *ngFor="let scope of globalScopes" label="{{scope.name}}">
                <ng-container *ngTemplateOutlet="tabContent"></ng-container>
            </mat-tab>
        </mat-tab-group>

        <ng-template #tabContent>
            <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-between center" fxLayout.lt-sm="column"
                 fxLayoutAlign.lt-sm="start" class="iwg-grid-filters mat-padding mlt-1 mlr-15" filterSection>

                <div>
                <span style="font-size: 15px;" class="mobileactive">
                  <span flex fxFlex="48" fxLayoutAlign="space-between center" style="font-size: 15px;">
                    {{assignmentLabelPlural}} Active From:</span>
                  <mat-datepicker-toggle flex fxFlex="11" fxLayoutAlign="space-between center" matSuffix [for]="start">
                  </mat-datepicker-toggle>
                  <mat-form-field appearance="none" color="accent" flex fxFlex="35">
                    <input matInput [matDatepicker]="start" [(ngModel)]="state.start"
                        [max]="state.end" (dateChange)="handleDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="start">
                      <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #start></mat-datepicker>
                  </mat-form-field>
                </span>
                </div>
                <div>
                <span class='ml-15 mobileactive'>
                  <span flex fxFlex="10" fxLayoutAlign="space-between center">To:</span>

                  <mat-datepicker-toggle flex fxFlex="20" fxLayoutAlign="space-between center" matSuffix [for]="end">
                  </mat-datepicker-toggle>
                  <mat-form-field appearance="none" color="accent" flex fxFlex="55">
                    <input matInput [matDatepicker]="end" [(ngModel)]="state.end"
                        [min] = "state.start"  (dateChange)="handleDateChange($event)">
                    <mat-datepicker-toggle matSuffix [for]="end">
                      <mat-icon matDatepickerToggleIcon>arrow_drop_down</mat-icon>
                    </mat-datepicker-toggle>
                    <mat-datepicker #end></mat-datepicker>
                  </mat-form-field>
                </span>
                </div>
                <div fxFlex="20" *ngIf="(state.global_scope != 3)" class='ml-15'>
                <span class="ml-10">
                  <app-country-select *ngIf="(state.global_scope != 3)" [selectedItem]="state.country" [idOnly]="true"
                                      [alltext]="'All'" [helptext]="''" (countryChange)="handleCountryChange($event);">
                  </app-country-select>
                </span>
                </div>
                <div fxFlex="20" class="assignemt-vista2" style="margin-top: 5px;">
                <span style="width: 100%;">
                  <mat-form-field flex>
                    <mat-label>Search</mat-label>
                    <input matInput [(ngModel)]="state.q" (input)="onSearchChange($event.target.value)">
                  </mat-form-field>
                </span>
                </div>
                <div fxFlex="3">
                <span class="ml-10 mobile-downloadbtn">
                  <button mat-icon-button aria-hidden="false" aria-label="Download" class="inputassignicon"
                          (click)="exporter.exportTable('csv', {fileName: 'quotes'})">
                    <mat-icon>file_download</mat-icon>
                  </button>
                </span>
                </div>

            </div>
        </ng-template>
    </div>

   
    <div class="wrapper1" #wrapper1>
        <div class="div1" #div1></div>
    </div>
    <div class="wrapper2" #wrapper2>
     
        <div class="div2" #div2>
            <mat-progress-bar color="accent" mode="indeterminate" *ngIf="loading"></mat-progress-bar>
            <mat-table #listTable matTableExporter matSort [dataSource]="dataSource" #exporter="matTableExporter"
                       [hiddenColumns]="hideColsInExport" (matSortChange)="sortData($event)" style="min-width: 100%;">

               
                <ng-container matColumnDef="DocumentID">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Document ID</mat-header-cell>
                    <mat-cell *matCellDef="let documents"
                              (click)="this.showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                        <span *ngIf="this.AssignmentStatusId == 14 && documents.DocumentStatusID == 1">  {{documents.DocID}}</span>
                    </mat-cell>
                    <mat-cell *matCellDef="let documents">
                        <span *ngIf="this.AssignmentStatusId != 14 && documents.DocumentStatusID != 1">  {{documents.DocID}}</span>
                    </mat-cell>
                </ng-container>

               
                <ng-container matColumnDef="DocumentType">
                    <mat-header-cell *matHeaderCellDef mat-sort-header>Document Type</mat-header-cell>
                    <mat-cell *matCellDef="let documents"
                              (click)="this.showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                        <span *ngIf="this.AssignmentStatusId == 14 && documents.DocumentStatusID == 1">   {{documents.DocumentTypeName}}</span>
                    </mat-cell>
                    <mat-cell *matCellDef="let documents"
                              (click)="this.showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                        <span *ngIf="this.AssignmentStatusId != 14 && documents.DocumentStatusID != 1">   {{documents.DocumentTypeName}}</span>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DocumentName">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Document Name
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.DocumentName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Notes">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Notes
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.Notes}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DateReceived">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Date Received</mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.ReceivedDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DateIssued">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Date Issued</mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.IssuedDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ExpirationDate">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Expiration Date</mat-header-cell>
                    <mat-cell *matCellDef="let documents">{{documents.ExpireDate | date:'MM/dd/yyyy'}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="UploadedBy">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Uploaded By
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.UploadedByName}} </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Status
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents"> {{documents.StatusName}}</mat-cell>
                </ng-container>
                <ng-container matColumnDef="Upload">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Upload</mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <button mat-button class="mat-icon-button" aria-label="More"
                                *ngIf="AssignmentStatusId == 14 && documents.DocumentStatusID == 1"
                                style="padding-left: 0px;"
                                (click)="this.showDocumentDialog($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID,documents.DocumentTypeName)">
                            <mat-icon>file_upload</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Download">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Download
                    </mat-header-cell>
                    <mat-cell *matCellDef="let documents">
                        <button mat-button class="mat-icon-button" aria-label="More" style="padding-left: 0px;"
                                *ngIf="documents.DocumentFileIDs != null && documents.DocumentFileIDs != ''"
                                (click)="this.downloadAllForDocument(documents.EvaluationDocumentTypeID)">
                            <md-icon>file_download</md-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <ng-container matColumnDef="DoesNotHave">
                    <mat-header-cell *matHeaderCellDef mat-sort-header disableClear>Does Not Have</mat-header-cell>
                            <mat-cell *matCellDef="let documents">
                                <button mat-button class="mat-icon-button" aria-label="More"
                                        *ngIf="AssignmentStatusId == 14 && (documents.DocumentStatusID == 1 || documents.DocumentStatusID == 4)"
                                        [disabled]="documents.DocumentStatusID == 4"
                                        style="padding-left: 0px;"
                                        (click)="this.changeToDoesNotHave($event,documents.EvaluationDocumentTypeID,documents.DocumentTypeID)">
                                    <mat-icon>not_interested</mat-icon>
                                </button>
                            </mat-cell>
                </ng-container>
                <ng-container matColumnDef="OprMenu">
                    <mat-header-cell *matHeaderCellDef class="hidexs"></mat-header-cell>
                    <mat-cell *matCellDef="let quotes" class="hidexs">
                        <button mat-icon-button [matMenuTriggerFor]="elementMenu" aria-label="Menu">
                            <mat-icon>more_vert</mat-icon>
                        </button>

                        <mat-menu #elementMenu="matMenu" class="submenu" let document>
                            <button mat-menu-item [disabled]="documents?.AssignmentStatusId != 14 || documents?.DocumentStatusID != 1">
                                <mat-icon>more_vert</mat-icon>
                            </button>
                            <button mat-menu-item *ngIf="documents?.DocumentStatusID==1" (click)="this.showDocumentDialog($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID,documents?.DocumentTypeName)">
                                Upload
                            </button>
                            <button mat-menu-item *ngIf="documents?.DocumentStatusID==1 && documents?.DocumentStatusID!=4"(click)="this.changeToDoesNotHave($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                Does Not Have
                            </button>
                            <button mat-menu-item *ngIf="documents?.EvaluationDocumentTypeID > 0 && documents?.StatusName!='Archive'" style="display:none" (click)="this.archieveDocument($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                Archive
                            </button>
                            <button mat-menu-item *ngIf="documents?.StatusName=='Archive'" style="display:none" (click)="this.unArchieveDocument($event,documents?.EvaluationDocumentTypeID,documents?.DocumentTypeID)">
                                UnArchive
                            </button>
                        </mat-menu>

                    </mat-cell>
                </ng-container>
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

        </div>
    </div>

    <mat-paginator [length]="totalRecords" [pageSize]="state.limit" class="myvista-paginator"
                   (page)="pageEvent = $event; naviatePageTo($event)" [pageSizeOptions]="[25, 100, 500, 1000, 10000]"
                   showFirstLastButtons>
    </mat-paginator>

</div>
